import { render, staticRenderFns } from "./TeacherEditView.vue?vue&type=template&id=3922b41c&scoped=true&"
import script from "./TeacherEditView.vue?vue&type=script&lang=js&"
export * from "./TeacherEditView.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEditView.vue?vue&type=style&index=0&id=3922b41c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922b41c",
  null
  
)

component.options.__file = "TeacherEditView.vue"
export default component.exports